import React from "react";
import { ReactComponent as Remove } from "../../../assets/icons/remove.svg";

/**
 * @param {Object} options
 * @param {(e: React.MouseEvent, id: string) => void} options.onRemove
 */
export function getConnectedPharmacistsListColumns({ onRemove }) {
  return [
    {
      id: "name",
      accessorKey: "name",
      header: "Name",
      cell: ({ row }) => <span>{row.original?.name ?? "—"}</span>,
    },
    {
      id: "job_title",
      accessorKey: "job_title",
      header: "Position",
      cell: ({ row }) => <span className="block">{row.original?.job_title ?? "—"}</span>,
    },
    {
      id: "remove",
      header: "Remove",
      enableSorting: false,
      cell: ({ row }) => (
        <div
          className="flex justify-end"
          onClick={(e) => e.stopPropagation()}
          onKeyDown={(e) => e.stopPropagation()}
          role="presentation"
        >
          <Remove
            className="cursor-pointer"
            onClick={(e) => onRemove(e, row.original.id)}
            data-testid={`connected-pharmacists-remove-${row.original.id}`}
          />
        </div>
      ),
      meta: { disableFilterMenu: true, align: "right" },
    },
  ];
}
